<div *ngIf="area" class="container-fluid">
    <div mat-dialog-title>
        <div *ngIf="area.area_ID">Edit Area</div>
        <div *ngIf="!area.area_ID">Add Area</div>
    </div>

    <div mat-dialog-content>
        <div class="form-inline mb-3">
            <span *ngIf="!area.area_ID">To add a new Area, complete the form below then click Submit.</span>
            <span *ngIf="area.area_ID">Make the necessary changes on the form below then click Submit</span>
            <span class="float-right warning col-sm-4">
                * Required Information
            </span>
        </div>

        <form #form="ngForm" (ngSubmit)="saveArea(form)">
            <div class="form-group form-inline">
                <span class="warning">* </span>
                <label class="col-form-label pr-2" for="name">Area Name</label>
                <div class="col-md-6">
                    <input id="name" name="name" class="form-control  col-md-12" [(ngModel)]="area.area_Name"
                           required #name="ngModel"
                           [class.field-error]="form.submitted && name.invalid">
                    <div [hidden]="!form.submitted || name.valid"
                         class="alert alert-danger">
                        Area Name is required
                    </div>
                </div>
            </div>

            <div class="form-group form-inline">
                <span class="warning">* </span>
                <label class="col-form-label pr-2" for="areaDesc">Description</label>
                <div class="col-md-10">
                    <textarea id="areaDesc" name="areaDesc" type="text"
                              class="form-control col"
                              [(ngModel)]="area.area_Desc"
                              required #areaDesc="ngModel"
                              [class.field-error]="form.submitted && areaDesc.invalid"></textarea>
                    <div [hidden]="!form.submitted || areaDesc.valid"
                         class="alert alert-danger">
                        Description is required
                    </div>
                </div>
            </div>
            <div *ngIf="dealerId" class="form-group form-inline">
                <label class="col-form-label pr-2" for="accessories">Area Accessories</label>
                <mat-select multiple class="col-md-6 form-control" [(value)]="selectedAreaAccessories">
                    <mat-option *ngFor="let item of idiAccessoryItems" [value]="item.item_ID">{{item.item_Name}}</mat-option>
                </mat-select>
            </div>
            <div *ngIf="!dealerId" class="form-group form-inline">
                <label class="col-form-label pr-2" for="accessories">Area Accessories</label>
                <mat-select multiple class="col-md-6 form-control" [(value)]="selectedAreaAccessories">
                    <mat-option *ngFor="let item of idiAccessoryItems" [value]="item.item_ID">{{item.item_Name}}</mat-option>
                </mat-select>
            </div>

            <div class="mt-3">
                <div [hidden]="!form.submitted || form.valid"
                     class="alert alert-danger">
                    Validation issues encountered.  Please review your entered information.
                </div>
            </div>
            <div *ngIf="errors" class="row alert alert-danger" role="alert">
                <strong>{{errors}}</strong>
            </div>
        </form>
    </div>
    <mat-dialog-actions align="end">
        <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3">Submit</button>
        <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md">Cancel</a>
    </mat-dialog-actions>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
</div>
